import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import styles from "./SelectRowsDropdown.module.scss";

export const SelectRowsDropdown = ({ onSelectRows, hasSelectedRows = false, onChangeStatusClick, onChangeTagsClick, onAssignClick, onArchiveClick }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleKeyDown = (event, action, itemId) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      // Always close dropdown when item is activated via keyboard
      setShowDropdown(false);
      
      if (action === "selectRows" && onSelectRows) {
        onSelectRows();
      } else if (action === "option1") {
        // Handle Option 1 action
        console.log("Option 1 clicked");
      } else if (action === "option2") {
        // Handle Option 2 action
        console.log("Option 2 clicked");
      } else if (itemId === "change-status" && onChangeStatusClick) {
        onChangeStatusClick();
      } else if (itemId === "change-tags" && onChangeTagsClick) {
        onChangeTagsClick();
      } else if (itemId === "assign" && onAssignClick) {
        onAssignClick();
      } else if (itemId === "archive" && onArchiveClick) {
        onArchiveClick();
      } else {
        // Handle other menu items
        console.log(`${itemId} clicked`);
      }
    }
  };

  const handleItemClick = (action, itemId) => {
    // Always close dropdown when item is clicked
    setShowDropdown(false);
    
    if (action === "selectRows" && onSelectRows) {
      onSelectRows();
    } else if (action === "option1") {
      // Handle Option 1 action
      console.log("Option 1 clicked");
    } else if (action === "option2") {
      // Handle Option 2 action
      console.log("Option 2 clicked");
      } else if (itemId === "change-status" && onChangeStatusClick) {
        onChangeStatusClick();
      } else if (itemId === "change-tags" && onChangeTagsClick) {
        onChangeTagsClick();
      } else if (itemId === "assign" && onAssignClick) {
        onAssignClick();
      } else if (itemId === "archive" && onArchiveClick) {
        onArchiveClick();
      } else {
        // Handle other menu items
        console.log(`${itemId} clicked`);
      }
  };

  const menuItems = hasSelectedRows
    ? [
        { id: "change-status", label: "Change Status" },
        { id: "change-tags", label: "Change Tags" },
        { id: "assign", label: "Assign" },
        { id: "archive", label: "Archive" },
      ]
    : [
        { id: "selectRows", label: "Select Rows", action: "selectRows" },
      ];

  return (
    <Dropdown align="end" show={showDropdown} onToggle={setShowDropdown}>
      <Dropdown.Toggle 
        as="div"
        className={styles.dropdownToggle} 
        variant="link"
      >
        <div className={styles.iconButton} aria-label="More options">
          <div className={styles.toolbarButtonInner}>
            <img
              src="/images/settings-v2/horizontal-dots.svg"
              alt=""
              className={styles.toolbarButtonIcon}
              width={16}
              height={16}
            />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenuWrapper}>
        <div className={styles.dropdownWrapper}>
          <div className={styles.dropdownMenu}>
            <div className={styles.dropdownList}>
              {menuItems.map((item, index) => (
                <div key={item.id} className={styles.dropdownListItem}>
                  <div
                    className={`${styles.dropdownItem} ${styles.dropdownItemDefault}`}
                    role="menuitem"
                    tabIndex={0}
                    onClick={() => handleItemClick(item.action, item.id)}
                    onKeyDown={(e) => handleKeyDown(e, item.action, item.id)}
                    aria-label={item.label}
                  >
                    <div className={styles.dropdownItemInner}>
                      <span className={styles.dropdownItemText}>
                        {item.label}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

